import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    root: {
        color: theme.palette.secondary.main,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '0 20px 0 20px',
        textAlign: 'center',
        justifyContent: 'space-between'
    },
    title: {
        marginTop: 80,
        marginBottom: 20
    },
    infoText: {
        margin: theme.spacing(2)
    },
	chart: {
		textAlign: '-webkit-center',
	},
    footer: {
        padding: theme.spacing(2),
        width: '100%'
    }
}));

export default useStyles;
